<markant-card
  outlined="true"
  class="role-card"
  [attr.data-cy]="'role-card-' + id"
  [class.role-card-disabled]="disabled"
  [class.role-card-clickable]="clickable"
  (click)="clickable && clicked.emit()"
  (keydown.enter)="clickable && clicked.emit()"
>
  <section slot="markant-card__content">
    <div class="role-card-title" [class.role-card-title-preview]="isPreview">
      <span class="service-role-name">{{ name }}</span>
      <div class="role-actions">
        <ng-content select="[role-actions]"></ng-content>
      </div>
    </div>
    <ng-content select="[role-details]"></ng-content>
  </section>
</markant-card>
